var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"scroll"},[_vm._t("topLoader"),_vm._v(" "),_c('div',{ref:"top"}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{ref:"bottom",attrs:{"data-test":"bottom-loader"}}),_vm._v(" "),_vm._t("bottomLoader")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }